import { mediasoupClientConfig } from "../components/mediasoup/mediasoup";

export async function getMeetingMedia(
  constraints: MediaStreamConstraints = {},
): Promise<MediaStream> {
  return navigator.mediaDevices.getUserMedia({
    audio: constraints.audio ?? mediasoupClientConfig.audioConstraints,
    video: constraints.video ?? mediasoupClientConfig.videoConstraints,
  });
}

export function setTrackEnabled(
  stream: MediaStream | null,
  kind: "audio" | "video",
  enabled: boolean,
): void {
  stream
    ?.getTracks()
    .filter((track) => track.kind === kind)
    .forEach((track) => {
      track.enabled = enabled;
    });
}

/** Phone or tablet (iPadOS reports "MacIntel", so detect it via touch points). */
export function isMobileOrTablet(): boolean {
  if (typeof navigator === "undefined") return false;
  return (
    /Android|iPhone|iPad|iPod|Mobile|Tablet|Silk|Kindle/i.test(
      navigator.userAgent,
    ) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

/**
 * Remote participants on phones/tablets must always use the front camera.
 * On those devices any deviceId is dropped and facingMode "user" is forced,
 * so device switches can never land on the back camera. No-op on desktop.
 */
export function lockFrontCamera(
  video: boolean | MediaTrackConstraints = true,
): boolean | MediaTrackConstraints {
  if (video === false || !isMobileOrTablet()) return video;
  const front: MediaTrackConstraints = video === true ? {} : { ...video };
  delete front.deviceId;
  front.facingMode = "user";
  return front;
}

/** True for cameras whose label marks them as rear-facing. */
export function isBackCameraLabel(label: string): boolean {
  return /back|rear|environment/i.test(label);
}
